'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fp = require('lodash/fp');

var _fp2 = _interopRequireDefault(_fp);

var _FilterCollection = require('../../Filters/FilterCollection');

var _FilterCollection2 = _interopRequireDefault(_FilterCollection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _FilterCollection2.default)('plans')('Stories', {
  filter: function filter(plan, _ref) {
    var values = _ref.values;

    var stories = _fp2.default.getOr(0, 'stories')(plan);

    if (!stories) {
      return false;
    }

    return (values || []).map(function (v) {
      return v.value;
    }).includes(stories);
  },
  collectValues: function collectValues(plans) {
    var stories = _fp2.default.flow([_fp2.default.map(function (plan) {
      return _fp2.default.getOr(0, 'stories')(plan);
    }), _fp2.default.uniq, _fp2.default.filter(Boolean), _fp2.default.sortBy(_fp2.default.identity), _fp2.default.map(function (count) {
      return {
        value: count
      };
    })])(plans);

    return stories;
  },

  labelRender: function labelRender(_ref2) {
    var value = _ref2.value;
    return value + ' ' + (value === 1 ? 'Story' : 'Stories');
  }
});


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-data/build/Plans/filters/Stories.js
// module id = 870
// module chunks = 0